export default __webpack_public_path__ + "static/media/chbox1-hover.70000283.svg";